<script setup>
import {ChevronRightIcon, HomeIcon} from '@heroicons/vue/20/solid';
import Button from '@/Components/Inputs/Button.vue';
import {inject} from "vue";

const route = inject('route');

defineProps({
    pages: Object,
    whiteText: Boolean,
});
</script>

<template>
    <nav
        aria-label="Breadcrumb"
        class="mx-auto flex max-w-7xl px-4 sm:px-6"
    >
        <ol
            class="absolute mt-2 flex items-center space-x-1 sm:mt-4 sm:space-x-4"
            role="list"
        >
            <li>
                <div>
                    <Button
                        :class="whiteText ? 'text-white' : 'text-gray-900'"
                        :href="route('public.home')"
                        class="hover:text-gray-700"
                        disable-style
                    >
                        <HomeIcon
                            aria-hidden="true"
                            class="size-4 shrink-0 sm:size-5"
                        />
                        <span class="sr-only">Home</span>
                    </Button>
                </div>
            </li>

            <li
                v-for="page in pages"
                :key="page.name"
            >
                <div class="flex items-center">
                    <ChevronRightIcon
                        :class="whiteText ? 'text-white' : 'text-gray-400'"
                        aria-hidden="true"
                        class="size-4 shrink-0 sm:size-5"
                    />
                    <Button
                        :aria-current="page.current ? 'page' : undefined"
                        :class="whiteText ? 'text-white' : 'text-gray-900'"
                        :href="page.href"
                        class="text-xs font-medium hover:text-gray-700 sm:ml-4 sm:text-sm"
                        disable-style
                    >
                        {{ page.name }}
                    </Button>
                </div>
            </li>
        </ol>
    </nav>
</template>
